<template>
  <div class="policyMessagePush">
    <div class="title">新增消息</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="消息内容：" prop="desc">
        <el-input
          type="textarea"
          v-model="ruleForm.desc"
          rows="5"
          placeholder="请输入"
        ></el-input>
        <span class="highlight" @click="selectSmsTemplate()">选择模板</span>
      </el-form-item>
      <el-form-item label="推送渠道：" prop="pushChannel">
        <el-checkbox-group
          v-model="ruleForm.pushChannel"
          @change="handleCheckedPushChannelChange"
        >
          <el-checkbox
            :label="item.value"
            name="type"
            v-for="(item, index) in pushChannelList"
            :key="index"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <!-- <el-alert :closable="false" show-icon>
          <template slot="title">
            <div>
              <div>注：1、若企业没有相对应的联系人，则消息发送失败</div>
              <div>
                2、接收人需要关注“丽水市企业服务综合平台”才能通过公众号接收该消息
              </div>
              <div>3、通过后台可查阅站内消息的阅读情况</div>
            </div>
          </template>
        </el-alert> -->
      </el-form-item>
      <el-form-item
        label="选择发送群："
        prop="ddMessage"
        v-if="ruleForm.pushChannel.includes(5)"
      >
        <el-select
          v-model="ruleForm.ddMessage"
          multiple
          placeholder="请选择钉钉群消息"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in ddGroupList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发送人昵称：" prop="name">
        <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="goBackList()">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </el-form-item>

      <div class="problemBox">
        <div class="problemTitle">常见问题：</div>
        <div>1.如何推送？</div>
        <div class="content">
          先填写消息内容，并选择好推送渠道，再选择要推送的企业。消息新建完成后无法修改，请确认好后再选择企业
        </div>
        <div>2.为什么有些企业会发送失败？</div>
        <div class="content">
          通过企业联系人的手机号码等用户信息发送对应渠道的消息。若发送失败请检查该用户是否存在该企业，以及信息是否填写正确。若要发送微信公众号消息，则需要先关注微信号
        </div>
        <div>3.如何发送钉钉群消息？</div>
        <div class="content">
          请先建立钉钉群并开通群智能机器人，在钉钉机器人管理页面添加机器人的Webhook，在此页面选择要发送的群。若发送失败请检查webhook是否正确
        </div>
      </div>
    </el-form>

    <el-dialog
      title="选择模板"
      :visible.sync="dialogTableVisible"
      class="selectTemplateBox"
    >
      <el-form>
        <el-form-item label="类别">
          <el-select
            v-model="categoryId"
            placeholder="请选择"
            @change="getSearch"
            clearable
          >
            <el-option
              v-for="item in smsTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div
          class="select-template-item"
          v-if="messageTemplateList && messageTemplateList.length > 0"
        >
          <el-radio
            v-model="templateRadio"
            :label="item.content"
            :key="index"
            v-for="(item, index) in messageTemplateList"
          >
            <div>{{ item.content }}</div></el-radio
          >
        </div>
        <div v-else class="no_data">暂无数据</div>

        <div
          class="table-page"
          v-if="messageTemplateList && messageTemplateList.length > 0"
        >
          <el-pagination
            background
            layout="total,prev, pager, next, sizes, jumper"
            :current-page.sync="pageNum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="totalRecord"
          >
          </el-pagination>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSelectSms()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="successPush"
      width="30%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      class="successDialog"
    >
      <div class="successContent">
        <i class="el-icon-success"></i>
        <div class="success-title">新建消息成功</div>
        <div
          v-if="
            ruleForm.pushChannel.length == 1 && ruleForm.pushChannel[0] == 5
          "
        >
          等待管理员审核
        </div>
        <div v-else>
          消息新建成功，请选择需要推送的企业。也可以稍后在列表页中找到选择企业的入口
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goBackList()">关 闭</el-button>
        <el-button
          type="primary"
          @click="backPolicyList()"
          v-if="
            !(ruleForm.pushChannel.length == 1 && ruleForm.pushChannel[0] == 5)
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addMovenSMS } from '@api/video/video'
import {
  categoryDictList,
  smsTemplatePage
} from '@/common/api/corporateInteraction/messageTemplate'
import { getRobotList } from '@api/common'
import { getArea } from '@api/common'
export default {
  name: 'PolicyMessagePush',
  data() {
    return {
      receiverList: [
        {
          label: '法人'
        },
        {
          label: '经办人'
        },
        {
          label: '财务'
        },
        {
          label: '人事'
        },
        {
          label: '行政'
        }
      ],
      pushChannelList: [
        {
          label: '手机短信',
          value: 0
        },
        {
          label: '微信公众号',
          value: 1
        },
        {
          label: '站内消息',
          value: 2
        },
        {
          label: '浙里办',
          value: 4
        },
        {
          label: '钉钉群消息',
          value: 5
        }
      ],
      ruleForm: {
        name: '',
        ddMessage: [],
        robotIds: [],
        type: [],
        desc: '',
        receiver: [],
        pushChannel: []
      },
      // 消息模板列表
      messageTemplateList: [],
      rules: {
        name: [
          { required: true, message: '请输入发送人昵称', trigger: 'blur' }
        ],
        ddMessage: [
          { required: true, message: '请选择发送群', trigger: 'change' }
        ],
        receiver: [
          {
            required: true,
            type: 'array',
            message: '请选择接收人',
            trigger: 'change'
          }
        ],
        pushChannel: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个推送渠道',
            trigger: 'change'
          }
        ],
        desc: [{ required: true, message: '请填写消息内容', trigger: 'blur' }]
      },
      dialogTableVisible: false,
      categoryId: '', // 选择模板类别
      pageNum: 1,
      pageSize: 10,
      totalRecord: 0,
      templateRadio: '', // 选中的模板
      dialogEntVisible: false,
      searchEntList: [],
      areaList: [], // 区域
      entLabel: '', // 企业标签
      smsTypeList: [], // 消息类别
      county: '', // 选择地区
      entName: '',
      creditCode: '',
      labelCodeStr: '',
      policyName: '', // 政策名称
      loading: false,
      timer: null,
      entListTimer: null, // 获取企业列表定时器
      entGroupIndex: 0,
      groupSize: 0,
      filterText: null,
      successPush: false, // 推送成功弹框
      smsSubject: 1,
      messageId: '',
      ddGroupList: []
    }
  },
  watch: {},
  mounted() {
    this.id = this.$route.query.id
    this.getRobotList()
  },
  methods: {
    goBackList() {
      this.$router.push({ name: 'messageManagement' })
    },
    getRobotList() {
      getRobotList().then((res) => {
        if (res.data.code == '0000') {
          this.ddGroupList = res.data.data
        }
      })
    },
    submitSelectSms() {
      this.dialogTableVisible = false
      this.ruleForm.desc = this.templateRadio
    },
    selectSmsTemplate() {
      this.dialogTableVisible = true
      this.getSearch()
      this.getCategoryList()
    },
    // 获取类别列表
    getCategoryList() {
      categoryDictList().then((res) => {
        if (res.data.code == '0000') {
          this.smsTypeList = res.data.data
        }
      })
    },
    // 消息模板列表搜索
    getSearch() {
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        key: this.key,
        categoryId: this.categoryId
      }
      smsTemplatePage(param).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.messageTemplateList = data.list
          this.totalRecord = data.total
        }
      })
    },
    // 地区
    getAreaList() {
      return new Promise((resolve, reject) => {
        getArea().then((res) => {
          if (res.data.code === '0000') {
            this.areaList = res.data.data
            resolve()
          }
        })
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addSms()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addSms() {
      const data = {
        recipients: this.ruleForm.receiver,
        content: this.ruleForm.desc,
        smsTypes: this.ruleForm.pushChannel,
        createBy: this.ruleForm.name,
        smsSubject: this.smsSubject,
        robotIds: this.ruleForm.ddMessage
      }
      addMovenSMS(data).then((res) => {
        if (res.data.code == '0000') {
          this.successPush = true
          this.messageId = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCheckedPushChannelChange(data) {
      console.log(data, '选择的推送渠道')
    },
    // 选择模板分页操作
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getSearch()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getSearch()
    },
    backPolicyList() {
      this.successPush = false
      this.$router.push({
        name: 'smsSelectEnt',
        query: {
          id: this.messageId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.policyMessagePush {
  width: 100%;
  height: 100%;
  background: #fff;
  .title {
    font-size: 16px;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
  }
  .problemBox {
    background: rgba(250, 251, 252, 1);
    padding: 20px;
    border-radius: 2px;
    border: 1px solid rgba(228, 228, 228, 1);
    font-size: 14px;
    color: rgba(51, 51, 51, 0.95);
    line-height: 20px;
    .problemTitle {
      margin-bottom: 20px;
    }
    .content {
      color: rgba(102, 102, 102, 0.65);
    }
  }
  /deep/.el-form {
    padding: 20px;
  }
  /deep/.el-alert {
    align-items: flex-start;
    background-color: rgba(230, 247, 255, 1);
    border: 1px solid rgba(145, 213, 255, 1);
    color: rgba(0, 0, 0, 0.65);
    i {
      color: #46a6ff;
    }
  }
  /deep/.el-form-item--medium .el-form-item__content {
    line-height: 32px;
  }
  /deep/.el-alert,
  /deep/.el-input__inner,
  /deep/.el-select,
  /deep/.el-textarea__inner {
    width: 50%;
  }
  /deep/.el-cascader {
    width: 68%;
  }
  /deep/.el-select,
  /deep/.el-cascader {
    .el-input__inner {
      width: 100%;
    }
  }
  .highlight {
    color: #46a6ff;
    display: inline-block;
    padding: 6px;
    cursor: pointer;
  }
  /deep/.el-dialog__body {
    padding: 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
  /deep/.dialog-footer {
    text-align: center;
  }
  .selectTemplateBox {
    /deep/.el-select {
      width: 30%;
    }
    .table-page {
      text-align: center;
      margin-top: 20px;
    }
    .select-template-item {
      border-top: 1px solid #eee;
      /deep/.el-radio {
        display: flex;
        align-items: center;
        height: 44px;
        border-bottom: 1px solid #eee;
        margin-right: 0;
        .el-radio__input {
          width: 10%;
          text-align: center;
        }
        .el-radio__input.is-checked + .el-radio__label {
          color: #606266;
        }
      }
    }
  }
  .no_data {
    height: 100px;
    font-size: 16px;
    color: #606266;
    text-align: center;
  }
  .successDialog {
    /deep/.el-dialog__body {
      padding: 50px 0;
      border: none;
    }
    .successContent {
      color: #000;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .success-title {
        font-size: 20px;
        font-weight: 600;
        margin: 20px 0;
      }
      i {
        color: #67c23a;
        font-size: 80px;
      }
    }
  }
}
</style>
